import { Paper } from "@mui/material";
import styled from "styled-components";

const VideoWrapper = styled(Paper)`
  && {
    display: ${(props) => (props.hidden ? "none" : "flex")};
    height: fit-content;
    width: 200px;
    max-width: 100%;
    position: relative;
    overflow: hidden;

    background: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(1.5px);
    -webkit-backdrop-filter: blur(1.5px);
    border: 1px solid rgba(255, 255, 255, 0.1);

    &:hover #focus-indicator {
      display: flex;
      cursor: pointer;
    }
  }
`;

const Video = styled("video")`
  z-index: 1;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
  display: ${(props) => (props.hidden ? "none" : "initial")};
`;

const ScreenShareVideo = styled(Video)`
  object-fit: contain;
`;

export { VideoWrapper, Video, ScreenShareVideo };
